export default "__VITE_ASSET__mVUeqFUg__"